/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {
  getFilenameForToast,
  getFileExtension,
  showToast,
  getShouldAutoHideToast,
  getIsMouseOverToast
} from "selectors/documentSelectors";
import { FilenameToast } from "components/document/FilenameToast";
import { inject } from "mobx-react";
import { getViewPortWidthWithoutPagesViewScrollbar } from "selectors/documentViewSelectors";

const mapStoreToProps = stores => ({
  shouldAutoHideToast: getShouldAutoHideToast(stores),
  fileName: getFilenameForToast(stores),
  isMouseOverToast: getIsMouseOverToast(stores),
  viewPortWidth: getViewPortWidthWithoutPagesViewScrollbar(stores),
  setDisplayToast: value => stores.documentStore.setDisplayToast(value),
  fileExtension: getFileExtension(stores).toUpperCase()
});

const FilenameToastContainer = inject(mapStoreToProps)(FilenameToast);

export { FilenameToastContainer };
